import cn from 'classnames';

import { useMediaQuery } from 'helpers/mediaQuery';

interface Props {
  text: React.ReactNode;
  title: React.ReactNode;
}

export function NoticeCard({ text, title }: Props) {
  const isScreenSm = useMediaQuery({ maxWidth: 'sm' });

  return (
    <div
      className={cn('flex max-w-[460px] flex-col bg-white', {
        'px-10 pb-10 pt-9': !isScreenSm,
        'p-6': isScreenSm,
      })}
    >
      <div className="block max-w-[400px] pb-4 text-20 font-medium leading-140% text-gray-700">
        {title}
      </div>
      <div className="block pb-9 text-16 font-medium leading-140% text-gray-600">
        {text}
      </div>
    </div>
  );
}
